module.exports = __webpack_public_path__ + "static/media/1.a0bd1c44.jpg";